/**
 * User API — /api/admin/user/*  (본인 프로필 / is_developer 토글)
 */
import { getJson, patchJson } from './http';

export interface Me {
  id: number; email: string; name: string; role: string; is_developer: boolean;
}

/** GET /api/admin/user/me */
export async function fetchMe(opts: { signal?: AbortSignal } = {}): Promise<Me> {
  return getJson<Me>('/api/admin/user/me', { signal: opts.signal });
}

/** PATCH /api/admin/user/me/developer — 본인 is_developer 토글(leader+) */
export async function setSelfDeveloper(is_developer: boolean): Promise<{ is_developer: boolean }> {
  return patchJson<{ is_developer: boolean }>('/api/admin/user/me/developer', { is_developer });
}
